import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteModule, getModules } from "../../redux/services/moduleSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { getCourses } from "../../redux/services/courseSlice";

const Module = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getModuleData = useSelector((state) => state?.module?.moduleData);
  const getCourseData = useSelector((state) => state?.course?.courseData?.course_data);
  // console.log("getCourseData", getCourseData)

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [courseFilter, setCourseFilter] = useState("")
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllCourses = useCallback(async () => {
    try {
      await dispatch(getCourses({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) { }
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllCourses();
  }, [getAllCourses]);

  const filterOptions = [
    { value: "", label: "All" },
    ...(getCourseData
      ? getCourseData?.map((course) => ({
        value: course?._id,
        label: course?.title,
      }))
      : ""),
  ];

  const getAllModules = useCallback(async () => {
    try {
      await dispatch(getModules({ page: page + 1, limit: pageLimit, searchData, courseId: courseFilter }));
    } catch (error) { }
  }, [dispatch, page, pageLimit, searchData, courseFilter]);

  useEffect(() => {
    getAllModules();
  }, [getAllModules]);

  const deleteModuleData = async () => {
    try {
      const response = await dispatch(deleteModule(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllModules();
    } catch (error) { }
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Name", key: "name" },
    { header: "Sub Title", key: "subTitle" },
    { header: "priority", key: "priority" },
    { header: "Total Lecture", key: "totalLecture" },
    { header: "Total Test", key: "totalTest" },
    {
      header: "Image",
      key: "image",
      render: (image) => <img src={image} alt="module" className="w-20 h-14 object-cover rounded-xl" />,
    },
    {
      header: "Link",
      key: "link",
      render: (link) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-primary underline">
          Visit
        </a>
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.COURSES.MODULE_ADD_EDIT}?moduleId=${row._id}`, { state: { row } });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table title="Modules" buttonTitle="Add Module" showSearchbar={true} searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchData={setSearchData} onAddClick={() => navigate(ROUTES.COURSES.MODULE_ADD_EDIT)} columns={columns} data={getModuleData?.module_data || []} actions={actions} filterOptions={filterOptions}
        onFilterChange={(e) => {
          setCourseFilter(e ? e.value : "");
        }} pageCount={getModuleData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} pageLimitOptions={limitOptions} selectedPageLimit={pageLimit} onPageLimitChange={setPageLimit} />
      {confirm && <ConfirmationPage topicName="Module" confirm={confirm} onDelete={deleteModuleData} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default Module;
